import CardHost from './card--host.js';

export default CardHost;
